import type { ModelListParams } from '../types'

/** Angular `authService` session key for model list filters. */
export const MODEL_LIST_SESSION_STORAGE_KEY = 'modellist_filter'

export const MODEL_LIST_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const

export const DEFAULT_MODEL_LIST_PARAMS: ModelListParams = {
  page: 1,
  perPage: 10,
  sortBy: 'asc',
  orderBy: 'model_name',
}

export const BASE_MODEL_ID = 1
